<template>
  <div :class="$style.newsArchivePage">
    <app-layout :render-left-column="false">
      <template slot="central-column">
        <div :class="$style['wrap']">
          <jtn-ui-side-block-header
            :class="$style['title']"
            :text="pageHeader"
          />
          <archive-filter
            :date="date"
            @submitFilter="onFilter"
          />
          <search-records-list
            v-if="showedResults"
            :page-type="'longreads'"
            :records="newsData"
          />
          <jtn-ui-typography
            v-else
            :class="$style['notice']"
            :tag="'div'"
            :type="'font-photoday-type-1'"
          >
            {{ noticeMessage }}
          </jtn-ui-typography>
          <jtn-ui-pagination
            v-model="pageData"
            v-if="showedResults"
            v-show="pageData.numPages && pageData.numPages > 1"
            :class="$style['pagination']"
            :items-per-page="params.pagesize"
            :total-items="totalResult"
            @change="changePage(pageData.currentPage)"
          />
        </div>
      </template>

      <template slot="right-column">
        <app-right-column />
      </template>
    </app-layout>
  </div>
</template>

<script>
import AppLayout from '../../../layout/containers/app-layout';
import AppRightColumn from '../../../layout/containers/app-right-column';
import { ArchiveFilter } from '../components/archive-filter';

import { PageAnalyticsMixin } from '../../../shared/mixins/page-analytics';
import { WindowScrollMixin } from '../../../shared/mixins/window-scroll.mixin';
import { CoreSearchLogicMixin } from '../../../shared/mixins/core-search-logic.mixin';

export default {
  name: 'LongreadsPage',
  components: {
    AppLayout,
    AppRightColumn,
    ArchiveFilter
  },
  mixins: [
    WindowScrollMixin,
    PageAnalyticsMixin,
    CoreSearchLogicMixin
  ],
  data() {
    return {
      params: {
        page: +this.$route.query.page || 1,
        pagesize: 20,
        dateFrom: this.$route.query.dateFrom || undefined,
        dateTo: this.$route.query.dateTo || undefined,
        templateAlias: 'longread'
      }
    };
  },
  computed: {
    pageHeader() {
      return 'Спецпроекты';
    }
  }
};
</script>

<style lang="scss" module>
@import 'styles';
@import '../../../styles/news-archive-page';
</style>
